import { Container } from '@mui/material';
import AdminLeftNav from '../components/AdminLeftNav';
import DashboardAppBar from '../components/DashboardAppBar';
import { updatePageTitle } from '../utilities/HelperFunctions';
import MainContentContainer from '../components/MainContentContainer';
import SideBarDrawer, { SideBarDrawerProps } from '../components/SideBarDrawer';
import { Outlet } from 'react-router-dom';

export default function AdminHome(props: SideBarDrawerProps) {
  const { widthUnderMd, openSideBarDrawer, setOpenSideBarDrawer } = props;
  updatePageTitle('Institution Dashboard');

  return (
    <>
      <MainContentContainer widthUnderMd={widthUnderMd} openSideBarDrawer={openSideBarDrawer}>
        <DashboardAppBar {...props} />

        <Container sx={{ py: 4.5 }}>
          <Outlet />
        </Container>
      </MainContentContainer>

      <SideBarDrawer
        variant={(widthUnderMd && openSideBarDrawer) ? 'temporary' : 'permanent'}
        open={openSideBarDrawer}
        onClose={() => setOpenSideBarDrawer(false)}
      >
        <AdminLeftNav {...props} />
      </SideBarDrawer>
    </>
  );
}
